import searcher 	from "@/components/info/searcher.vue"
import EventBus 	from "@/event-bus"
import { func } 	from "joi";
import dates 		from "@/components/info/dates.vue"
import menus 		from "@/components/info/menus.vue"
import TimelinePlayback from "@/components/TimelinePlayback/TimelinePlayback.vue"
import LPRAlertModal from "@/components/Modals/LPRAlertModal.vue"
import AlertSmartEventModal from "@/components/Modals/AlertSmartEventModal.vue"

export default{
	name 		: 'playback2',
	// extends: Line,

	components  : {
		searcher,		
		dates,
		menus,
		TimelinePlayback,
		LPRAlertModal,
		AlertSmartEventModal,
		// GChart
		// LineChart,
		// events
	}, // components
	data : (vm) => ({
		
		info 				: {},
		info_search 		: {
			groups: [] // Valor inicial para grupos
		},		
		tabs  				: null,
		activeTab 			: 0, // Tab activa: 0 = Timeline, 1 = Video Segments
		info_search_fields 	: [
			{
				key 		: 'search',
				text 		: 'search',
				placeholder : 'device',
				list 		: 'list_devices',
				key_list	: 'deviceId',
				text_list 	: 'name',
				type 		: 'select_searcher',
				key_search  : 'name',
				key_search_1 : 'deviceId',
				visible 	: true,
				cols 		: {
					col : 2,
				},
			},
			{
				key 		: 'dates',
				text 		: 'date',
				placeholder : 'select',
				type 		: 'date_range',
				use_input   : true,
				visible 	: true,
				cols 		: {
					col : 3,
				},
			},
			{
				key 		: 'start',
				menu 		: 'picker_start',
				ref 		: 'menu_start',
				text 		: 'Start',
				placeholder : 'time',
				type 		: 'time_picker',
				visible 	: true,
				cols 		: {
					col : 2,
				},
			},
			{
				key 		: 'end',
				menu 		: 'picker_end',
				ref 		: 'menu_end',
				text 		: 'End',
				placeholder : 'time',
				type 		: 'time_picker',
				visible 	: true,
				cols 		: {
					col : 2,
				},
			},
			{
				key 		: 'analytic',
				text 		: 'analytic',
				placeholder : 'select',
				list 		: 'list_analytics',
				key_list	: 'name',
				text_list 	: 'name',
				type 		: 'select',
				multiple 	: false,  
				visible 	: false,
				cols 		: {
					col : 1,
				},
			},
			
			// option ext
			{
				key  :  'plate_char',
				text :  'plate',
				type :  'text',
				visible 	 : false,					
				placeholder  : 'type a plate',
				ref_analytic : 'lpr',
				cols 		: {
					col : 1,
				},

			},
			{
				key 		: 'tags',
				text 		: 'tags',					
				list 		: 'list_objects',
				placeholder : 'select',
				ref_analytic : 'object',					
				/*key_list	: 'name',
				text_list 	: 'name',*/
				type 		: 'select',
				multiple 	: true,  
				visible 	: false,
				cols 		: {
					col : 1,
				},
			},
			{
				key 		: 'motion',
				text 		: 'motion',					
				list 		: 'list_motions',
				placeholder : 'select',
				ref_analytic : 'motion',					
				/*key_list	: 'name',
				text_list 	: 'name',*/
				type 		: 'select',
				multiple 	: true,  
				visible 	: false,
				cols 		: {
					col : 1,
				},
			},
			{
				key 		: 'anomalies',
				text 		: 'anomalies',					
				list 		: 'list_anomalies',
				placeholder : 'select',
				ref_analytic : 'anomalies',					
				/*key_list	: 'name',
				text_list 	: 'name',*/
				type 		: 'select',
				multiple 	: true,  
				visible 	: false,
				cols 		: {
					col : 1,
				},
			},
			{
				key  :  'entity',
				text :  'face',
				type :  'select_searcher',					
				list :  'list_entitys',
				placeholder : 'select',
				ref_analytic : 'face',					
				key_list	: 'name',
				text_list 	: 'name',
				type 		: 'select',
				key_search  : 'name',
				key_search_1 : 'id_tracker',
				multiple 	: true,  
				visible 	: false,
				cols 		: {
					col : 1,
				},
			},
			{
				key  :  'actions',
				text :  'actions',
				type :  'select',
				list : 'list_actions',
				placeholder : 'select',
				ref_analytic : 'actions',
				multiple 	: true,
				visible 	: false,
				cols 		: {
					col : 1,
				},
			},
			{
				key 		: 'groups',
				text 		: 'groups',
				type 		: 'select',
				list 		: 'list_groups',
				key_list	: 'value',
				text_list 	: 'text',
				placeholder : 'select_groups',
				multiple 	: true,
				visible 	: true,
				cols 		: {
					col : 2,
				},
			},
			{
				key 		: 'btn',
				action 		: 'search',					
				ref 		: 'search',
				text 		: 'search',
				placeholder : 'btn',
				type 		: 'btn',
				color 		: 'primary',
				visible 	: true,
				cols 		: {
					col : 1,
				},
			},


		],
		list_devices 	: [],
		list_search 	: [],
		row_analytic 	: [],
		menu 		 	: false,
		dates 		 	: [], 	
		menu_picker 	: {
			start	: false, // menu
			end		: false,			
		},
		picker 			: {
			start	: "00:00", // 
			end		: "23:59",
		},

		show 		 	: true,
		ID_notification : 'playback2',
		options 		: { itemsPerPage : 30 },
		total 			: 0,
		
     	size_height		: 100,
		size_width 		: 100,
		videoTimeline 	: [],
		height_video  	: window.innerHeight * 0.40,
		indexPLay 		: 0,
		video 			: {
			urlpath : ""
		},
		url_video  		: vm.$URL,//'http://localhost:9090',
		list_analytics 	: [ 
			'lpr', 
			'motion', 
			'object', 
			'face', 
			/*'gun', 
			'person', 
			'human actions', 
			*/
			'actions',
			'anomalies'
		],
		list_analytics_tags : [ // for no have second option
			/*'lpr' ,
			'object' ,	
			'face'   ,				
			'actions',*/
			'anomalies', 
			'motion',
		],
		select_idx_analytic : null,
		datacollection : null,
		height : 100,
		pagination:{
			visible: 5,
			total: 0,			
			items: 0,
			found: true,
			
		},
		page: 1,
		offsetTop: 0,
		height_row : 370,		
		sliders : {
			max : 200,
			min : 1
		},
		loading : false,
		message : {
			msg     : '',
			success : false,
			error   : false,
		},
		list_tags 		: [],
		height_tag 		: 100,
		height_row_tag 	: 370,
		pagination_tag  : {
			visible : 5,
			total   : 0,			
			items   : 0,
			found   : true,
			
		},
		page_tag 		: 1,
		offsetTop_tag  	: 0,
		loading_tag 	: false,
		show_timeline	: false,
		ready_timeline:false,
		message_tag  	: {
			msg     : '',
			success : false,
			error   : false,
		},
		timelineHoverInfo: null, // Información del item hovered en el timeline
		// Control de carga de imágenes
		currentImageLoadAbortController: null,
		imageLoadTimeout: null,
		currentEvidenceUrl: '', // URL actual de evidencia para evitar bucle infinito
		// Modal LPR
		showLPRModal: false,
		lprEventData: null,
		lprVideoData: null,
		// Navegación LPR
		currentLPRIndex: 0,
		lprEventsInCategory: [],
		currentLPRCategory: null,
		// Modal Alert & Smart Event
		showAlertSmartEventModal: false,
		alertSmartEventData: null,
		alertSmartEventBucketEvents: [], // Eventos del bucket obtenidos del API
		alertSmartEventLoadingEvents: false, // Estado de carga de eventos
		// Navegación Alert & Smart Event
		currentAlertSmartIndex: 0,
		alertSmartEventsInCategory: [],
		currentAlertSmartCategory: null,
		// Modal para Object Events
		showObjectModal: false,
		objectEventData: null,
		objectVideoData: null,
		objectVideoLoading: false,
		objectVideoError: false,
		// Navegación de objetos
		currentObjectIndex: 0,
		objectsInCategory: [],
		currentObjectCategory: null,
		alertSmartEventVideoData: null,
		list_actions : [
			'Hands -up',
			'Walking',
			'Fighting',
			'Calling',
			'Falling',
			'Sitting',
			'Standing',						
		],
		list_objects : [
			'person',
			'gun',				
			'car'
									
		],
		list_entitys : [],
		tags_analytics : null,
		list_anomalies : ['anomalies'],
		list_motions   : ['motion'],
		list_groups : [
			{ value: 'LPR', text: '🚗 LPR' },
			{ value: 'Actions', text: '⚡ Actions' },
			{ value: 'SmartEvent', text: '🧠 Smart Events' },
			{ value: 'Records', text: '📹 Records' },
			{ value: 'Alerts', text: '🚨 Alerts' },
			{ value: 'Objects', text: '🎯 Objects' },
			{ value: 'Axle', text: '🛞 Axle' },
			{ value: 'Counter', text: '🔢 Counter' }
		],
		first_request  : false,
		start_ti:false,		
        src_img 	: vm.$logos.login_night,
        
		bus 		: {},
		downloads 	: {
			type : 'current',
			list : [],
			text : 'current_videos',
		},
		loading_download : false,
		info_menu : {
			head : {
				tag  	  	: 'download',
				icon  	  	: 'mdi-menu',
				icon_size 	: 'small',
				skip_br   	: true,
				btn  	  	: true,
				btn_size  	: "x-small", 
				color_btn   : "primary",
			},
			options : {
				multiple  : false,
				type 	  : 'select',
				item_text : 'text',
				action    : 'sel_tag',	
				close_on_content : true,

			}
		},
		options_downloads : [
			{
				key  	: 'current',
				text 	: 'current_videos',
				tooltip : 'this option download the current page', 
			}
			,{
				key  	: 'all',
				text 	: 'all',
				tooltip : 'this option download the range selected', 
			},
			{
				key  : 'select',
				text : 'select_videos',
				tooltip : 'this option download the select selected', 

			},
		],
		info_req  : {},
		selecteds : [],
		selects   : [],
		 		last_search 	: "",		
 		searchTimeline  : null,
		videoPlayerRef  : null, // Referencia al reproductor de video
		intersectionObserver: null, // Observer para lazy loading de videos
	}), // data  

	created(){		
		let devs = this.$store.getters["Devices/list"];

		if (devs && devs.length > 0) {
			this.list_devices = [ ...devs ];
		}else
		if (localStorage.getItem('list_devices')) {
			this.list_devices = JSON.parse(localStorage.getItem('list_devices'));
		}
		
		// Inicializar info_search con valores por defecto
		this.info_search = {
			search: null,  // Se llenará cuando el usuario seleccione un device
			dates: [],
			start: "00:00",
			end: "23:59"
		};
		
		// setting format      
      	this.$Format.update_list('ml', this.$ml);
	}, // created

	watch : {
		page: function(val){
			// Clean up current observer before loading new page
			if (this.intersectionObserver) {
				this.intersectionObserver.disconnect();
			}
			this.get_list();
		}, //page

		// Watcher para actualizar la referencia del reproductor de video
		url_video: function(newUrl) {
			this.updateVideoPlayerRef();
		}, // url_video

		// Watcher para cuando el video esté disponible en el DOM
		'$refs.video_play': function(newRef) {
			if (newRef) {
				this.updateVideoPlayerRef();
			}
		}, // $refs.video_play

		// Watcher para cuando se cambie de pestaña
		activeTab: function(newTab) {
			// Si se cambia a la pestaña del video (tab 0), actualizar la referencia
			if (newTab === 0) {
				this.$nextTick(() => {
					this.updateVideoPlayerRef();
				});
			}
		}, // activeTab

		/*slider_time: function(current){
			if (current) {
				//console.log("SLIDER : ", current, this.videoTimeline[this.indexPLay])
				if (this.videoTimeline[this.indexPLay]) {
					let video = this.videoTimeline[this.indexPLay];

					if (video && video.duration > 0 ) {
						video.element.currentTime = current;
					}
				}

			}
		}, // */

	}, // watch
	computed:{
		currentHeight: function(){			
			return this.$vuetify.breakpoint.height 
		},
		// Navegación de objetos
		totalObjectsInCategory() {
			return this.objectsInCategory.length;
		},
		canNavigatePrevious() {
			return this.currentObjectIndex > 0;
		},
		canNavigateNext() {
			return this.currentObjectIndex < this.objectsInCategory.length - 1;
		},
		// Navegación LPR
		totalLPREvents() {
			return this.lprEventsInCategory.length;
		},
		canNavigateLPRPrevious() {
			return this.currentLPRIndex > 0;
		},
		canNavigateLPRNext() {
			return this.currentLPRIndex < this.lprEventsInCategory.length - 1;
		},
		// Navegación Alert & Smart Event
		totalAlertSmartEvents() {
			return this.alertSmartEventsInCategory.length;
		},
		canNavigateAlertSmartPrevious() {
			return this.currentAlertSmartIndex > 0;
		},
		canNavigateAlertSmartNext() {
			return this.currentAlertSmartIndex < this.alertSmartEventsInCategory.length - 1;
		},
		// Computed properties para cachear valores formateados del hover y evitar recalcularlos
		hoverFormattedStart() {
			if (!this.timelineHoverInfo || !this.timelineHoverInfo.item || !this.timelineHoverInfo.item.start) {
				return '';
			}
			return this.formatTimelineDate(this.timelineHoverInfo.item.start);
		},
		hoverFormattedEnd() {
			if (!this.timelineHoverInfo || !this.timelineHoverInfo.item || !this.timelineHoverInfo.item.end) {
				return '';
			}
			return this.formatTimelineDate(this.timelineHoverInfo.item.end);
		},
		hoverFormattedDuration() {
			if (!this.timelineHoverInfo || !this.timelineHoverInfo.item || !this.timelineHoverInfo.item.start || !this.timelineHoverInfo.item.end) {
				return '';
			}
			return this.formatDuration(this.timelineHoverInfo.item.end.getTime() - this.timelineHoverInfo.item.start.getTime());
		},
		hoverEventCount() {
			if (!this.timelineHoverInfo || !this.timelineHoverInfo.item || !this.timelineHoverInfo.item.metadata) {
				return null;
			}
			return this.timelineHoverInfo.item.metadata.eventCount || this.timelineHoverInfo.item.metadata.cantidadEventos || null;
		},
	}, // computed
	methods : {
		//actions requireds
		actions(act, item, opt){			
			switch (act){
				case ('set_dates') : {
					// this.dates = item;
					this.menu = false;
				}break;
				case ('search') : {
					this.get_list(true);
					
					// También forzar la búsqueda en el timeline después de un breve delay
					this.$nextTick(() => {
						if (this.$refs.timelinePlayback && this.$refs.timelinePlayback.forceSearch) {
							
							this.$refs.timelinePlayback.forceSearch();
						} else {
							// console.warn("⚠️ [Playback] TimelinePlayback ref not available or forceSearch method not found");
						}
					});
				}break;
				case ('set_type_download'):{						
					if (item && item.key) {
						this.downloads.type = item.key; 
						this.downloads.text = item.text;
						if (item.key == 'select') {
							let vm = this;
							vm.videoTimeline.some((vt)=>{
								if (vt && vt.active) {
									vt.active = false;
									return true
								}
							})
						}
					}else{
						// console.warn("Not found type option download")
					}
				}break;
				case ('clear_listeners') : {
					
				}break;
				case ("clear_groups") : {
					
				}break;
				default : {
					
				}
			};
		}, // actions

		// Método para actualizar la referencia del reproductor de video
		updateVideoPlayerRef() {
			// Usar $nextTick para asegurar que el DOM esté actualizado
			this.$nextTick(() => {
				if (this.$refs.video_play) {
					this.videoPlayerRef = this.$refs.video_play;
					
				} else {
					this.videoPlayerRef = null;
					
				}
			});
		}, // updateVideoPlayerRef

		// list de devices dinamic
		render_listed (list){
			return this[list];
		}, // render listed

		formatDate (date) {
	        if (!date) return null

	        const [year, month, day] = date.split('/')
	        return `${year}-${month}-${day}`
	    
	    }, // formatDate
		
		// save times 
		save_time(key, item, ref){
			
			this.$refs[ref][0].save(this.picker[key])
			this.picker[key] = item;
			// this.$refs[item].save(picker[item_search.key])
		},

		next_video(){
			this.indexPLay++
			if ( this.videoTimeline[this.indexPLay]) {

				this.video 		= this.videoTimeline[this.indexPLay];
				this.url_video  = '';
				const timer = setTimeout(()=>{
					this.url_video  = this.video && this.video.urlpath ? 
									this.$URL + this.video.urlpath : ''; 
					this.onResize();
					clearTimeout(timer)
				}, 500)
			}else{
			
				this.indexPLay --;
				this.render_message(this.$ml.get('data_no_found'), 'error') 
			}
		},
		start_Playback(){
			this.indexPLay++
			if (this.videoTimeline[this.indexPLay]) {
				this.video 		= this.videoTimeline[this.indexPLay]
				this.url_video  = this.video && this.video.urlpath ? 
								 this.$URL + this.video.urlpath : '';
			}else{
				
				this.indexPLay --;
			}
		}, // start playback
		sel(video, index, selection_videos){				
			if (selection_videos) {
				this.selection_videos(video, index);
			}else
			if (video && index >= 0) {
				
				this.video 								  = this.videoTimeline[index];
				this.videoTimeline[this.indexPLay].active = false;
				this.videoTimeline[index].active 		  = true;
				this.indexPLay 					  		  = index;
				this.url_video   						  = '';
				const timer = setTimeout(()=>{
					this.url_video  = this.video && this.video.urlpath ? 
									this.$URL + this.video.urlpath : ''; 
					
					// this.onResize();
					clearTimeout(timer)
				}, 500)
			}
		}, // sel

		onScroll (e) {
    		this.offsetTop = e.target.scrollTop
  		}, // onScroll

  		// response of components videos 
  		onResize(val) {				
  			 
		 	if (this.$refs && this.$refs.card_segments && this.$refs.card_segments.$el && this.$refs.card_segments.$el.clientHeight) {
		 		let rest 	 = 	this.$refs.card_segments.$el.clientHeight - 40; 
		 		let rest_tag = rest;
		 		const timer_resize = setTimeout(()=>{
			 		if (this.$refs.video_play) {
			 			rest = this.$refs.video_play.clientHeight  - 40;
			 			this.height 	= rest;			 				 				
			 		}else{
			 			if (this.$refs.video_play_content && this.$refs.video_play_content.$el && this.$refs.video_play_content.$el.clientHeight) {
			 				rest = this.$refs.video_play_content.$el.clientHeight ;
			 				this.height 	= rest;
			 			}				 			
			 		}

			 		clearTimeout(timer_resize);
		 		}, 1500)			 		
			}else{
				
			}
		}, //on Resize

		// for refresh videos of thumbnails 
		set_time_lapse(){
			let list = this.videoTimeline;
			let vm   = this;
			vm.sliders.max = 1;
			// This method is now deprecated in favor of lazy loading
			// Lazy loading is initialized from get_data_axios
			
		}, // set time lapse

		// Clean up resources when component is destroyed
		cleanupLazyLoading() {
			if (this.intersectionObserver) {
				this.intersectionObserver.disconnect();
				this.intersectionObserver = null;
			}
			
			// Clear loading queue and batch
			this.loadingQueue = [];
			this.loadingBatch.clear();
			this.currentLoads = 0;
			
			
		},

		// Initialize Intersection Observer for lazy loading with batch processing
		initializeLazyLoading() {
			// Clean up existing observer
			if (this.intersectionObserver) {
				this.intersectionObserver.disconnect();
			}

			// Initialize loading queue and batch management
			this.loadingQueue = [];
			this.maxConcurrentLoads = 3; // Reduced from unlimited to 3 simultaneous loads
			this.currentLoads = 0;
			this.loadingBatch = new Set();

			// Create new Intersection Observer with optimized settings
			this.intersectionObserver = new IntersectionObserver((entries) => {
				
				
				// Process entries in batches to avoid overwhelming the system
				const processEntries = () => {
					entries.forEach(entry => {
						const video = entry.target;
						const videoIndex = parseInt(video.dataset.videoIndex);
						
						
						
						if (entry.isIntersecting) {
							// Only load if not already loaded and not in current batch
							if (this.videoTimeline[videoIndex] && 
								!this.videoTimeline[videoIndex].lazyLoaded && 
								!this.loadingBatch.has(videoIndex)) {
								
								this.addToLoadingQueue(video, videoIndex);
							} 
						} else {
							// Video is no longer visible - consider unloading to save memory
							this.handleVideoUnload(video, videoIndex);
						}
					});
					
					// Process the loading queue
					this.processLoadingQueue();
				};

				// Use requestIdleCallback with timeout fallback, avoid requestAnimationFrame
				if (window.requestIdleCallback) {
					window.requestIdleCallback(processEntries, { timeout: 1000 });
				} else {
					// Use setTimeout instead of requestAnimationFrame to reduce CPU usage
					setTimeout(processEntries, 100);
				}
			}, {
				root: null, // Use viewport as root instead of scroll-target
				rootMargin: '50px', // Reduced margin to load videos closer to viewport
				threshold: 0.1 // Single threshold for better performance
			});

			// Observe all video elements with a delay to ensure DOM is ready
			setTimeout(() => {
				let observedCount = 0;
				let totalVideos = this.videoTimeline.length;
				
				
				
				this.videoTimeline.forEach((video, index) => {
					const videoElement = document.getElementById('video_event' + index);
					// Only observe videos with valid URLs
					if (videoElement && video.urlpath) {
						// Mark as not loaded initially - critical for preventing auto-load
						this.$set(this.videoTimeline[index], 'lazyLoaded', false);
						this.$set(this.videoTimeline[index], 'loading', false);
						this.$set(this.videoTimeline[index], 'error', false);
						this.$set(this.videoTimeline[index], 'loaded', false);
						
						// Ensure video source is set to data URL to prevent warnings
						const sourceElement = videoElement.querySelector('source');
						if (sourceElement) {
							sourceElement.src = "data:video/mp4;base64,";
						}
						
						// Observe the video element
						this.intersectionObserver.observe(videoElement);
						observedCount++;
						
					} else if (videoElement && !video.urlpath) {
						// Mark videos without URLs as errors immediately
						this.$set(this.videoTimeline[index], 'error', true);
						this.$set(this.videoTimeline[index], 'ready', true);
						
					} 
				});
				
				
			}, 50); // Additional delay to ensure DOM readiness
		},

		// Add video to loading queue with priority
		addToLoadingQueue(videoElement, videoIndex) {
			const priority = this.calculateVideoPriority(videoElement, videoIndex);
			const queueItem = {
				videoElement,
				videoIndex,
				priority,
				timestamp: Date.now()
			};
			
			// Insert based on priority (higher priority first)
			let inserted = false;
			for (let i = 0; i < this.loadingQueue.length; i++) {
				if (priority > this.loadingQueue[i].priority) {
					this.loadingQueue.splice(i, 0, queueItem);
					inserted = true;
					break;
				}
			}
			
			if (!inserted) {
				this.loadingQueue.push(queueItem);
			}
			
			
		},

		// Calculate video loading priority based on visibility and position
		calculateVideoPriority(videoElement, videoIndex) {
			let priority = 0;
			
			// Higher priority for videos closer to viewport center
			const rect = videoElement.getBoundingClientRect();
			const viewportCenter = window.innerHeight / 2;
			const distanceFromCenter = Math.abs(rect.top + rect.height / 2 - viewportCenter);
			
			// Closer to center = higher priority
			priority += Math.max(0, 100 - distanceFromCenter / 10);
			
			// Higher priority for videos that are more visible
			const visibilityRatio = Math.min(rect.height, window.innerHeight - Math.max(0, rect.top)) / rect.height;
			priority += visibilityRatio * 50;
			
			// Lower priority for videos that are far from viewport
			if (rect.top > window.innerHeight * 2) {
				priority -= 50;
			}
			
			return Math.max(0, priority);
		},

		// Process loading queue with concurrency control
		processLoadingQueue() {
			while (this.loadingQueue.length > 0 && this.currentLoads < this.maxConcurrentLoads) {
				const queueItem = this.loadingQueue.shift();
				this.startVideoLoad(queueItem.videoElement, queueItem.videoIndex);
			}
		},

		// Start loading a video with concurrency tracking
		startVideoLoad(videoElement, videoIndex) {
			if (this.loadingBatch.has(videoIndex)) {
				return; // Already loading
			}
			
			this.loadingBatch.add(videoIndex);
			this.currentLoads++;
			
			
			
			// Load the video
			this.loadVideoLazily(videoElement, videoIndex);
		},

		// Handle video completion (success or failure)
		onVideoLoadComplete(videoIndex, success = true) {
			this.loadingBatch.delete(videoIndex);
			this.currentLoads = Math.max(0, this.currentLoads - 1);
			
			
			
			// Process next items in queue
			this.processLoadingQueue();
		},

		// Handle video unloading when no longer visible
		handleVideoUnload(videoElement, videoIndex) {
			// Pause video when it leaves viewport to reduce CPU
			if (videoElement && videoElement.tagName === 'VIDEO') {
				try {
					if (!videoElement.paused) {
						videoElement.pause();
					}
				} catch (e) {
					// Ignore pause errors
				}
			}
			
			// Only unload if video is far from viewport to save memory
			const rect = videoElement.getBoundingClientRect();
			const isFarFromViewport = rect.bottom < -window.innerHeight || rect.top > window.innerHeight * 2;
			
			if (isFarFromViewport && this.videoTimeline[videoIndex] && this.videoTimeline[videoIndex].loaded) {
				
				// Clear video source to free memory
				const sourceElement = videoElement.querySelector('source');
				if (sourceElement) {
					sourceElement.src = "data:video/mp4;base64,";
				}
				
				// Mark as unloaded but keep metadata
				this.$set(this.videoTimeline[videoIndex], 'loaded', false);
				this.$set(this.videoTimeline[videoIndex], 'lazyLoaded', false);
				
				// Re-observe for potential reloading
				this.intersectionObserver.observe(videoElement);
			}
		},

		// Load individual video lazily when it enters viewport
		loadVideoLazily(videoElement, videoIndex) {
			let vm = this;
			const lazySrc = videoElement.dataset.lazySrc;
			
			
			
			// Validate inputs
			if (!lazySrc || !this.videoTimeline[videoIndex] || this.videoTimeline[videoIndex].lazyLoaded) {
				
				return;
			}

			// Validate URL format - skip empty or invalid URLs
			if (!lazySrc.trim() || lazySrc === '#t=0.5') {
				
				this.$set(this.videoTimeline[videoIndex], 'error', true);
				this.$set(this.videoTimeline[videoIndex], 'loading', false);
				return;
			}

			// Mark as loaded to prevent duplicate loading
			this.$set(this.videoTimeline[videoIndex], 'lazyLoaded', true);
			this.$set(this.videoTimeline[videoIndex], 'loading', true);
			
			// Add event listeners for better handling
			const onLoadedData = () => {
				if (vm.videoTimeline[videoIndex]) {
					vm.videoTimeline[videoIndex].element = videoElement;
					if (videoElement.duration) {
						vm.videoTimeline[videoIndex].duration = videoElement.duration;
						vm.sliders.max += videoElement.duration;
					}
					vm.$set(vm.videoTimeline[videoIndex], 'loading', false);
					vm.$set(vm.videoTimeline[videoIndex], 'loaded', true);
					
					// Notify completion to batch management
					vm.onVideoLoadComplete(videoIndex, true);
				}
				cleanup();
			};
			
			const onError = (event) => {
				
				if (vm.videoTimeline[videoIndex]) {
					vm.$set(vm.videoTimeline[videoIndex], 'ready', true);
					vm.$set(vm.videoTimeline[videoIndex], 'loading', false);
					vm.$set(vm.videoTimeline[videoIndex], 'error', true);
					
					// Notify completion to batch management (with error)
					vm.onVideoLoadComplete(videoIndex, false);
					
					// Try to reset the source to prevent further errors
					const sourceElement = videoElement.querySelector('source');
					if (sourceElement) {
						sourceElement.src = "data:video/mp4;base64,";
					}
				}
				cleanup();
			};

			const onLoadStart = () => {
				// Video started loading
				if (vm.videoTimeline[videoIndex]) {
					vm.$set(vm.videoTimeline[videoIndex], 'loading', true);
				}
			};
			
			const cleanup = () => {
				videoElement.removeEventListener('loadeddata', onLoadedData);
				videoElement.removeEventListener('error', onError);
				videoElement.removeEventListener('loadstart', onLoadStart);
				videoElement.removeEventListener('loadedmetadata', () => {});
				videoElement.removeEventListener('canplay', () => {});
			};
			
			// Add event listeners
			videoElement.addEventListener('loadeddata', onLoadedData);
			videoElement.addEventListener('error', onError);
			videoElement.addEventListener('loadstart', onLoadStart);
			
			// Additional error handling for decode issues
			videoElement.addEventListener('loadedmetadata', () => {
				if (vm.videoTimeline[videoIndex]) {
					vm.$set(vm.videoTimeline[videoIndex], 'loading', false);
					
				}
			});
			
			videoElement.addEventListener('canplay', () => {
				if (vm.videoTimeline[videoIndex]) {
					vm.$set(vm.videoTimeline[videoIndex], 'loading', false);
					vm.$set(vm.videoTimeline[videoIndex], 'loaded', true);
					
				}
			});
			
			// Set source and load the video
			try {
				// Find the source element and set its src directly
				const sourceElement = videoElement.querySelector('source');
				if (sourceElement) {
					
					sourceElement.src = lazySrc;
					videoElement.load();
				} else {
					
					this.$set(this.videoTimeline[videoIndex], 'error', true);
					this.$set(this.videoTimeline[videoIndex], 'loading', false);
					return;
				}
			} catch (error) {
				
				onError(error);
				return;
			}
		},


		// refresh main video
		set_url_video(video, type){
			let vm 		 = this;
			vm.url_video = '';
			const timer = setTimeout(()=>{
				if (type == 'object') { // segments videos
					vm.url_video = video && video.urlpath ? 
					 				vm.$URL + video.urlpath : '';
				}else{ // timeline
					vm.url_video = video ? this.$URL + video : '';
				}
				// vm.onResize();
				// vm.set_time_lapse();
				clearTimeout(timer);
			},50)
		}, // set url video


		 get_list(pag = false){
		 	// Solo vaciar la lista en búsqueda nueva; al cambiar de página no refrescar toda la vista
			if (pag) {
				this.videoTimeline = [];
			}
	    	let info_search 	= this.info_search;
	    	let info_up 		= null;
	    	let pg 				= this.page;
	    	let tags1  			= [];
	    	let entity1			= [];
	    	let plate 			= null;
	    	let groups1			= [];
	    	let timeZone 		= this.$timezone;
	    	
	    	if (info_search) {
	    		
	    		
	    		// render info to search

	    		if (this.info_search.dates && this.info_search.dates.length > 0) {
	    			this.dates =  this.info_search.dates; // ["2023/04/28", "2023/04/28"]//
	    			// console.log("📅 [Playback] Dates set from search:", this.dates);
	    		}
	    		if (this.info_search.start) {
	    			this.picker.start = this.info_search.start;
	    			// console.log("⏰ [Playback] Start time set:", this.picker.start);
	    		}
	    		if (this.info_search.end) {
	    			this.picker.end = this.info_search.end;
	    			// console.log("⏰ [Playback] End time set:", this.picker.end);
	    		}

	    		let formated_dates = this.$Format.format_date_time(this.dates, this.picker, true);
	    		// console.log("📅 [Playback] Formatted dates:", formated_dates);
	    		
	    		// console.log("Formated dates playback ", formated_dates);
	    		if (formated_dates == 'required_range_24h') {
	    			// console.log("⚠️ [Playback] 24h range required");
	    			this.$EventBus.$emit('notifications_modal',{
	    				type 	: 'warning',
	    				message : this.$ml.get('required_range_24h')
	    			})
	    			return false
	    		}
		    	let date1 = formated_dates.start,// this.$momentz(this.$momentz.now()).format('YYYY/MM/DD'), // L
		    		date2 = formated_dates.end;
	    		
				// console.log("⏰ [Playback] Final date range:", { date1, date2 });

				if (info_search.tags && info_search.tags.length > 0 ) {
					tags1 = info_search.tags;
					// console.log("🏷️ [Playback] Tags found:", tags1);
				}
				if (info_search.anomalies && info_search.anomalies.length > 0 ) {
					tags1 = tags1.concat(info_search.anomalies);
					// console.log("🚨 [Playback] Anomalies added to tags:", info_search.anomalies);
				}
				if (info_search.motion && info_search.motion.length > 0) {
					tags1 = tags1.concat(info_search.motion);
					// console.log("🎬 [Playback] Motion added to tags:", info_search.motion);						
				}
				if (info_search.actions && info_search.actions.length > 0) {
					tags1 = tags1.concat(info_search.actions);
					// console.log("🎭 [Playback] Actions added to tags:", info_search.actions);
				}

				if (info_search.entity && info_search.entity.length > 0) {
					entity1 = info_search.entity;
					// console.log("👥 [Playback] Entities found:", entity1);
				}
				if (info_search.plate_char) {
					plate = info_search.plate_char;
					// console.log("🚗 [Playback] Plate character:", plate);
				}

				if (info_search.groups && info_search.groups.length > 0) {
					groups1 = info_search.groups;
					// console.log("📊 [Playback] Groups selected:", groups1);
				}

		    	if (pag) {
		    		pg = 1;
		    		// console.log("🔄 [Playback] Pagination reset to page 1");
		    	}

		    	// set info to search (incluye page por si el backend lo usa en el body)
	    		info_up = {
	    			start 	 	:  date1, 
	    			end 	 	:  date2,		    			
	    			deviceId  	:  info_search.search, 
	    			tags 		:  tags1,
	    			entity 		:  entity1,
	    			plate_char  :  plate,
	    			groups 		:  groups1,
	    			timeZone,
	    			page 		:  pg
	    		};
	    		
	    		// console.log("📤 [Playback] Final search parameters:", info_up);
	    		
	    		/*momentz.tz(data.start, "YYYY/MM/DD_HH-mm-ss",timezone);    		
	    		startTime.clone()
	    		utcclonadostart.utc().valueOf()*/

		    	// console.log("🚀 [Playback] Making API request with params:", info_up);
		    	const api 	= this.$URL + '/api/v1/records/find';
		    	const api1 	= this.$URL + '/api/v1/object/find';
		    	if (info_up.deviceId) {
		    		// console.log("✅ [Playback] Device ID found, calling get_data_axios");
					this.get_data_axios(api, info_up, pg, [], "object");
		    	}else{		    		
		    		// console.log("⚠️ [Playback] No device ID found, showing warning");
		    		this.$EventBus.$emit('notifications_modal',{
		    			type 	: 'warning',
		    			message : this.$ml.get('req_sel_device'),
		    		});
		    	}
	    	}else{
	    		// console.log("❌ [Playback] No search info available");
	    	}
	    	
	    }, // get list	

	    render_message(msg, type){	    	
	    	if (msg && type) {		    	
	    		this.message[type] 	= true;
	    		this.message.msg 	= msg; 
	    		const timer = setTimeout(()=>{
	    			this.message[type] = false;
	    			this.message.msg   = ''; 
	    			clearTimeout(timer);
	    		}, 2000)
    		
	    	}

	    }, // render message

	    render_no_found(){
	    	let vm = this;
	    	if (this.url_video !== vm.$URL) {
		    	vm.url_video = '';
				const timer_no_found = setTimeout(()=>{
					vm.url_video = vm.$URL;
					vm.onResize();
					this.pagination = {
      					visible: 5,
						total: 1,			
						items: 0,
						found: true,
      				};
      				clearTimeout(timer_no_found);
					// vm.set_time_lapse();

				},1000)
	    	}else{	    		
	    		const timer_no_found = setTimeout(()=>{					
					vm.onResize();
					this.pagination = {
      					visible: 5,
						total: 1,			
						items: 0,
						found: true,
      				};
      				clearTimeout(timer_no_found);
					// vm.set_time_lapse();
				},1000)
	    	}
	    }, // render no found	     
		render_analytic_option(key, item){			
	 		if (key == 'analytic') {
	 			let vm 				= this;
	 			let analytics 		= this.list_analytics; // this.list_analytics_tags; //
	 			let idx_analytic  	= null;
	 			if (!analytics.includes(item)) {
	 				idx_analytic = vm.info_search_fields.findIndex( x => x &&  x.ref_analytic == 'object' );
	 				/*let list_sel = 'list_' + item;
	 				if ( item != 'anomalies') {
	 					list_sel += 's';
	 				}
	 				vm.info_search_fields[idx_analytic].list = list_sel ;*/
	 			}else{
	 				idx_analytic = vm.info_search_fields.findIndex( x => x &&  x.ref_analytic == item );
	 			}	 			
	 			if (idx_analytic >= 0) {
	 				if (vm.select_idx_analytic) {
	 					vm.info_search_fields[vm.select_idx_analytic].visible = false;
	 				}
	 				vm.select_idx_analytic  = idx_analytic;
	 				vm.info_search_fields[idx_analytic].visible = true;
	 			}
	 		}
	 	}, // render_analytic_option


	 	// virtual keyboard
	 	keyboard_is_active(keys, id_notification, type, obj ){
		    let key_board = false;
		    if (localStorage.getItem('virtual_Key_board')) {
		      key_board = JSON.parse(localStorage.getItem('virtual_Key_board'));
		    }       
		    // console.log(key_board , "KEYbOARD ACTIVE ")
		    if (key_board) {              
		        
		      EventBus.$emit('active_keyboard_key',{
		        ID   : id_notification,
		        key  : keys,
		        type,
		        obj
		      });
		    }       
		}, // keyboard_is_active

	 	onInputChange(input){
			//console.log("on input change", input)
			this.input = input.target.value;
		}, // onInputChange		

		get_data_axios(api, info_up, page = 0 , list = [], source){
			let  vm = this;
			
			// console.log("🚀 [Playback] get_data_axios called:", {
			//	api: api,
			//	info_up: info_up,
			//	page: page,
			//	source: source,
			//	timestamp: new Date().toISOString()
			// });
			
			// page++
			this.loading 			= true;
			// this.loading_timeline  	= true;
			// this.info_req 			= info_up;
			
			let newapi = api + "/?page=" + page;								
			
			// console.log("🌐 [Playback] Making API request to:", newapi);
			
			// console.log("Check comparation : equal ", temp === this.last_search, "\n diff " ,temp != this.last_search, temp,  " === ", this.last_search)

			this.$axios.post(newapi, info_up).then( res => {
				//console.log(res.data)
				this.loading 	= false;
				list 			= res.data.rows;
				
				// console.log("✅ [Playback] API Response received:", {
				//	hasData: !!res.data,
				//	rowsCount: res.data?.rows?.length || 0,
				//	hasPages: !!res.data?.pages,
				//	totalPages: res.data?.pages || 0,
				//	responseSize: JSON.stringify(res.data).length,
				//	timestamp: new Date().toISOString()
				// });
				
				let temp 		= this.$Helper.to_string(info_up);					
				if(res && list && list.length > 0){
					// console.log("📊 [Playback] Processing video timeline data:", {
					//	originalCount: list.length,
					//	firstVideo: list[0],
					//	lastVideo: list[list.length - 1]
					// });
					
					list.sort(function(a,b){
					  // Turn your strings into dates, and then subtract them
					  // to get a value that is either negative, positive, or zero.
					  return    new Date(b.createdAt) - new Date(a.createdAt);
					});
					vm.videoTimeline = list;
					vm.indexPLay	 = 0;
					vm.video  		 = list[0]
					this.set_url_video(vm.video,'object');
					
					// Initialize lazy loading for new video list with delay
					setTimeout(() => {
						this.initializeLazyLoading();
					}, 100); // 100ms delay to ensure DOM is fully rendered
					

				
					let item 		= list.length;							
					let pages		= res.data && res.data.pages ? res.data.pages : '';
	      				
					this.pagination = {
	      					visible: 5,
							total: pages,			
							items: item,
							found: true,
	      			};
					this.render_message(this.$ml.get('data_found'), 'success');
																		
				}else{
					// console.log("⚠️ [Playback] No video data found in response");
					this.render_message(this.$ml.get('data_no_found'), 'error');						
					// this.last_search 	= temp;
					
					// if (res && res.data && res.data.count && paseInt(res.data.count) == 0) {
						// this.actions("clear_listeners");
						// this.actions("clear_groups");
					// }
					// this.loading_timeline  	= false;

					if (page == 1) {
						this.$EventBus.$emit('notifications_modal', {
							type 		: 'warning',
							message 	: this.$ml.get('data_no_found'),
						});
					}
				}
				// console.log("🔍 [Playback] Search comparison:", {
				//	currentSearch: temp,
				//	lastSearch: this.last_search,
				//	areEqual: temp === this.last_search,
				//	willUpdateTimeline: temp !== this.last_search
				// });
				
				// Solo actualizar searchTimeline en página 1 para que Timeline llame find_analytics una vez.
				// Al cambiar de página (2, 3...) no tocar searchTimeline y no disparar find_analytics.
				if (page === 1) {
					const searchWithTimestamp = {
						...info_up,
						searchTimestamp: Date.now()
					};
					this.searchTimeline = searchWithTimestamp;
				}
				this.last_search = temp;
				
				// console.log("✅ [Playbook] searchTimeline FORCE updated successfully:", this.searchTimeline);
				// console.log("🔍 [Playbook] searchTimeline has start/end?", {
				//	hasStart: !!this.searchTimeline.start,
				//	hasEnd: !!this.searchTimeline.end,
				//	start: this.searchTimeline.start,
				//	end: this.searchTimeline.end,
				//	deviceId: this.searchTimeline.deviceId,
				//	timestamp: this.searchTimeline.searchTimestamp
				// });				
				
			}).catch(er => {
				// console.error("❌ [Playback] API Error:", er);
				this.loading 			= false;
				// this.loading_timeline  	= false;
				let temp 				= this.$Helper.to_string(info_up);					
				this.last_search 		= temp;
				// this.actions("clear_groups");

				this.$EventBus.$emit('notifications_modal',{
					type 		: 'error',
					message 	: er,
				})
			});
		}, // get data axios

		
		

		download_video(uri, name){
			if (uri) {

				if (name == 'video') {
					this.downloadUri(uri)
				}else if( ['current' ,'all', 'select'].includes(name) ){
					let uri1 = uri;
					if (name == 'all') {
						// uri1 = this.items;
						if (this.$refs && this.$refs.timelinePlayback) {
							uri1 = this.$refs.timelinePlayback.items;							
						}
					}
					if (name == "select" ){
						uri1 = this.selecteds;	
					}
					if (uri1 && uri1.length > 0) {
						let vm = this;

						uri1.forEach((uri_video) => {
							if (uri_video && (uri_video.urlpath || uri_video.evidence)) {
								const timer = setTimeout(()=>{
									let temp_uri = uri_video.urlpath || uri_video.evidence;
									vm.downloadUri(this.$URL + temp_uri);
									clearTimeout(timer)
								}, 2000)
							}
						})
					}
				} 
			}
							
		}, // download video
		
		downloadUri(uri){
			this.loading_download = true;
			let vm 				  = this;
			if (uri) {					
				let xhr = new XMLHttpRequest();
				xhr.open('GET', uri, true);
				xhr.responseType = 'blob';
				xhr.onload = function() {
				    let urlCreator = window.URL || window.webkitURL;
				    // console.log("download : ", this.response, urlCreator)
				    let imageUrl = urlCreator.createObjectURL(this.response);
				    let tag 	 = document.createElement('a');
				    let namefile = uri.split("/");
				    if (namefile && namefile.length > 0) {
				    	namefile = namefile[namefile.length - 1];
				    }
				    // console.log("file : ", namefile, uri);

				    tag.href 	 = imageUrl;
				    tag.target 	 = '_blank';
				    tag.download = namefile; //'sample.mp4';
				    document.body.appendChild(tag);
				    tag.click();
				    document.body.removeChild(tag);
					vm.loading_download = false;

				};
				xhr.onerror = err => {
				   this.$EventBus.$emit('notifications_modal',{ 
				   		type 	: 'warning', 
				   		message : this.$ml.get('fail_down_video') 
				   	});
					vm.loading_download = false;

				};
				xhr.send();
			}else{
				this.$EventBus.$emit('notifications_modal',{ 
					type 	: 'warning', 
					message : this.$ml.get('video_down_not_found') 
				});
				this.loading_download = false;
			}
		}, // downloadUri
		
		selection_videos(item, idx){
			if (this.selecteds.includes(item)) {
				this.selecteds.splice(this.selecteds.indexOf(item) , 1);
				}else{
					this.selecteds.push(item);
				}
				

		}, // sel

		// Método para sincronizar los controles de fecha con el timeline
		syncDateControlsWithTimeline(timelineData) {
			if (!timelineData) {
				// console.warn("⚠️ [Playback] No timeline data provided for sync");
				return;
			}

			try {
				// Actualizar las fechas del componente
				if (timelineData.startDate && timelineData.endDate) {
					this.dates = [timelineData.startDate, timelineData.endDate];
				}

				// Actualizar los tiempos del componente
				if (timelineData.startTime) {
					this.picker.start = timelineData.startTime;
				}

				if (timelineData.endTime) {
					this.picker.end = timelineData.endTime;
				}

				// Actualizar info_search con las claves que usa el formulario
				if (timelineData.startDate && timelineData.endDate) {
					this.info_search.dates = [timelineData.startDate, timelineData.endDate];
				}

				if (timelineData.startTime) {
					this.info_search.start = timelineData.startTime;
				}

				if (timelineData.endTime) {
					this.info_search.end = timelineData.endTime;
				}

				// Forzar la reactividad de Vue
				this.$forceUpdate();

			} catch (error) {
				// console.error("❌ [Playback] Error syncing date controls with timeline:", error);
			}
		},

		// Método para obtener el estado actual de los controles de fecha
		getDateControlsState() {
			return {
				dates: this.dates,
				picker: this.picker,
				info_search: this.info_search,
				timestamp: new Date().toISOString()
			};
		},

		// Método para manejar el hover de items del timeline
		// DESHABILITADO: Hover deshabilitado para evitar problemas de memoria
		handleTimelineItemHover(hoverInfo) {
			// Limpiar cualquier información de hover existente
			this.timelineHoverInfo = null;
			this.cancelPreviousImageLoad();
			this.currentEvidenceUrl = '';
			
			/* Código deshabilitado - hover desactivado
			// Cancelar carga anterior si existe
			this.cancelPreviousImageLoad();
			
			if (hoverInfo && hoverInfo.itemId) {
				// Reconstruir objeto con Date objects solo cuando sea necesario para el template
				// Esto evita crear objetos Date innecesariamente y reduce memory leaks
				this.timelineHoverInfo = {
					item: {
						id: hoverInfo.itemId,
						content: hoverInfo.content,
						start: hoverInfo.start ? new Date(hoverInfo.start) : null,
						end: hoverInfo.end ? new Date(hoverInfo.end) : null,
						className: hoverInfo.className,
						metadata: hoverInfo.metadata,
						group: hoverInfo.groupId
					},
					group: {
						id: hoverInfo.groupId,
						content: hoverInfo.groupContent
					}
				};
			} else {
				// Limpiar completamente para liberar memoria
				this.timelineHoverInfo = null;
				// Forzar garbage collection si está disponible
				if (window.gc) {
					window.gc();
				}
			}
			*/
		},

		// Método para manejar clics en eventos LPR
		handleLPREventClick(eventData) {
			console.log('LPR Event clicked:', eventData);
			
			// Guardar datos del evento
			this.lprEventData = eventData.eventData;
			
			// Inicializar navegación
			this.initializeLPRNavigation(eventData.eventData);
			
			// Mostrar el modal
			this.showLPRModal = true;
			
			// Buscar video automáticamente
			this.$nextTick(() => {
				this.searchVideoForLPR({
					timestamp: eventData.timestamp,
					deviceId: eventData.deviceId,
					eventData: eventData.eventData
				});
			});
		},

		// Método para cerrar el modal LPR
		closeLPRModal() {
			this.showLPRModal = false;
			this.lprEventData = null;
			this.lprVideoData = null;
			// Limpiar navegación
			this.currentLPRIndex = 0;
			this.lprEventsInCategory = [];
			this.currentLPRCategory = null;
		},

		// Método para buscar video para el evento LPR
		async searchVideoForLPR(searchData) {
			try {
				console.log('Searching video for LPR event:', searchData);
				
				// Convertir timestamp a número si es string
				let timestamp = searchData.timestamp;
				if (typeof timestamp === 'string') {
					timestamp = parseInt(timestamp);
				}
				
				// Usar el método del TimelinePlayback para buscar video
				if (this.$refs.timelinePlayback && this.$refs.timelinePlayback.findClosestVideoByTimestamp) {
					const result = await this.$refs.timelinePlayback.findClosestVideoByTimestamp(
						timestamp,
						searchData.deviceId
					);
					
					
					
					const video = result && result.videoData && (result.videoData.video || result.videoData.closestVideo);
					if (result && result.success && result.videoData && video && video.urlpath) {
						this.lprVideoData = {
							videoUrl: this.$URL + video.urlpath,
							videoData: result.videoData,
							searchResult: result
						};
						
						console.log('Video data set:', this.lprVideoData);
						
						// Notificar al modal que se encontró el video
						this.$nextTick(() => {
							if (this.$refs.lprModal) {
								this.$refs.lprModal.setVideoData(this.lprVideoData);
							}
						});
					} else {
						console.warn('No video found for LPR event:', result);
						// Limpiar datos de video si no se encuentra
						this.lprVideoData = null;
					}
				} else {
					console.warn('TimelinePlayback reference not available');
				}
			} catch (error) {
				console.error('Error searching video for LPR event:', error);
				this.lprVideoData = null;
			}
		},

		// Método para abrir video en el reproductor principal
		openVideoInMainPlayer(videoData) {
			try {
				console.log('Opening video in main player:', videoData);
				
				// Usar el método del TimelinePlayback para abrir el video
				if (this.$refs.timelinePlayback && this.$refs.timelinePlayback.openVideoInMainPlayer) {
					this.$refs.timelinePlayback.openVideoInMainPlayer(
						videoData.videoData,
						videoData.eventData.metadata.unixTimestamp
					);
				}
				
				// Cerrar el modal después de abrir el video
				this.closeLPRModal();
			} catch (error) {
				console.error('Error opening video in main player:', error);
			}
		},

		// Método para abrir video de objeto en el reproductor principal
		openObjectVideoInMainPlayer() {
			try {
				console.log('Opening object video in main player:', this.objectVideoData);
				
				// Usar el método del TimelinePlayback para abrir el video
				if (this.$refs.timelinePlayback && this.$refs.timelinePlayback.openVideoInMainPlayer) {
					this.$refs.timelinePlayback.openVideoInMainPlayer(
						this.objectVideoData.videoData,
						this.objectEventData.metadata.unixTimestamp
					);
				}
				
				// Cerrar el modal después de abrir el video
				this.closeObjectModal();
			} catch (error) {
				console.error('Error opening object video in main player:', error);
			}
		},

		// Métodos para manejar eventos del video en el modal
		onObjectVideoLoaded() {
			console.log('Object video loaded successfully in modal');
		},

		onObjectVideoError() {
			console.error('Error loading object video in modal');
			this.objectVideoError = true;
		},

		// Método para descargar el video del objeto
		downloadObjectVideo() {
			try {
				if (this.objectVideoData && this.objectVideoData.videoUrl) {
					console.log('Downloading object video:', this.objectVideoData.videoUrl);
					
					// Usar el método existente de descarga
					this.download_video(this.objectVideoData.videoUrl, 'object_video');
				} else {
					console.warn('No video URL available for download');
				}
			} catch (error) {
				console.error('Error downloading object video:', error);
			}
		},

		// Método para buscar video manualmente
		searchVideoManually() {
			try {
				if (!this.objectEventData) {
					console.warn('No object event data available for manual search');
					return;
				}

				
				
				// Obtener timestamp y deviceId de diferentes fuentes
				const timestamp = this.objectEventData.metadata?.unixTimestamp || 
								  this.objectEventData.start || 
								  this.objectEventData.metadata?.timestamp;
				const deviceId = this.objectEventData.metadata?.deviceId || 
								 this.search?.deviceId;

				console.log('Manual search params:', { timestamp, deviceId });

				if (timestamp) {
					this.searchVideoForObjectEvent({
						timestamp: timestamp,
						deviceId: deviceId,
						eventData: this.objectEventData
					});
				} else {
					console.warn('No timestamp available for manual video search');
					this.objectVideoError = true;
				}
			} catch (error) {
				console.error('Error in manual video search:', error);
				this.objectVideoError = true;
			}
		},

		// Método para inicializar la navegación de objetos
		initializeObjectNavigation(currentObject) {
			try {
				if (!currentObject || !currentObject.metadata) {
					console.warn('Invalid object data for navigation initialization');
					return;
				}

				// Obtener la categoría del objeto actual
				const objectType = currentObject.metadata.objectType;
				const subgroup = currentObject.metadata.subgroup;
				
				// Determinar la categoría para filtrar
				this.currentObjectCategory = {
					objectType: objectType,
					subgroup: subgroup
				};

				console.log('Initializing navigation for category:', this.currentObjectCategory);

				// Obtener todos los objetos de la misma categoría del timeline
				this.loadObjectsInCategory(currentObject);

			} catch (error) {
				console.error('Error initializing object navigation:', error);
			}
		},

		// Método para cargar objetos de la misma categoría
		loadObjectsInCategory(currentObject) {
			try {
				// Obtener items del timeline
				if (!this.$refs.timelinePlayback || !this.$refs.timelinePlayback.items) {
					console.warn('TimelinePlayback reference not available');
					return;
				}

				const allItems = this.$refs.timelinePlayback.items;
				console.log('All timeline items:', allItems);

				// Filtrar objetos de la misma categoría
				this.objectsInCategory = allItems.filter(item => {
					return item.metadata && 
						   item.metadata.isObject &&
						   item.metadata.objectType === this.currentObjectCategory.objectType &&
						   item.metadata.subgroup === this.currentObjectCategory.subgroup;
				});

				// Ordenar por timestamp
				this.objectsInCategory.sort((a, b) => {
					const timestampA = a.metadata?.unixTimestamp || a.start;
					const timestampB = b.metadata?.unixTimestamp || b.start;
					return timestampA - timestampB;
				});

				// Encontrar el índice del objeto actual
				this.currentObjectIndex = this.objectsInCategory.findIndex(item => 
					item.id === currentObject.id
				);

				if (this.currentObjectIndex === -1) {
					this.currentObjectIndex = 0;
				}

				console.log('Objects in category:', this.objectsInCategory);
				console.log('Current object index:', this.currentObjectIndex);

			} catch (error) {
				console.error('Error loading objects in category:', error);
			}
		},

		// Método para navegar al objeto anterior
		navigateToPreviousObject() {
			try {
				if (!this.canNavigatePrevious) {
					console.warn('Cannot navigate to previous object');
					return;
				}

				const previousIndex = this.currentObjectIndex - 1;
				const previousObject = this.objectsInCategory[previousIndex];

				console.log('Navigating to previous object:', previousObject);

				if (previousObject) {
					this.navigateToObject(previousObject, previousIndex);
				}

			} catch (error) {
				console.error('Error navigating to previous object:', error);
			}
		},

		// Método para navegar al objeto siguiente
		navigateToNextObject() {
			try {
				if (!this.canNavigateNext) {
					console.warn('Cannot navigate to next object');
					return;
				}

				const nextIndex = this.currentObjectIndex + 1;
				const nextObject = this.objectsInCategory[nextIndex];

				console.log('Navigating to next object:', nextObject);

				if (nextObject) {
					this.navigateToObject(nextObject, nextIndex);
				}

			} catch (error) {
				console.error('Error navigating to next object:', error);
			}
		},

		// Método para navegar a un objeto específico
		navigateToObject(object, index) {
			try {
				console.log('Navigating to object:', object, 'at index:', index);

				// Actualizar índice actual
				this.currentObjectIndex = index;

				// Actualizar datos del objeto
				this.objectEventData = object;

				// Limpiar datos de video anteriores
				this.objectVideoData = null;
				this.objectVideoLoading = false;
				this.objectVideoError = false;

				// Buscar video para el nuevo objeto - usar el mismo método que smart events
				const timestamp = object.metadata?.unixTimestamp || object.start;
				const deviceId = object.metadata?.deviceId || this.search?.deviceId;

				if (timestamp) {
					this.$nextTick(() => {
						this.searchVideoForAlertSmartEvent({
							timestamp: timestamp,
							deviceId: deviceId,
							eventData: object
						});
					});
				}

				console.log('Navigation completed to object:', object.id);

			} catch (error) {
				console.error('Error navigating to object:', error);
			}
		},

		// Métodos de navegación Alert & Smart Event
		initializeAlertSmartNavigation(currentEvent, eventType) {
			try {
				if (!currentEvent || !currentEvent.metadata) {
					console.warn('Invalid Alert/Smart event data for navigation initialization');
					return;
				}

				// Para Alert/Smart Events, agrupamos por tipo de evento
				this.currentAlertSmartCategory = {
					eventType: eventType
				};

				console.log('Initializing Alert/Smart navigation for type:', eventType);

				// Obtener todos los eventos del mismo tipo
				this.loadAlertSmartEventsInCategory(currentEvent, eventType);

			} catch (error) {
				console.error('Error initializing Alert/Smart navigation:', error);
			}
		},

		loadAlertSmartEventsInCategory(currentEvent, eventType) {
			try {
				// Obtener items del timeline
				if (!this.$refs.timelinePlayback || !this.$refs.timelinePlayback.items) {
					console.warn('TimelinePlayback reference not available');
					return;
				}

				const allItems = this.$refs.timelinePlayback.items;
				console.log('All timeline items:', allItems);

				// Filtrar eventos del mismo tipo
				this.alertSmartEventsInCategory = allItems.filter(item => {
					if (eventType === 'alert') {
						return item.metadata && item.metadata.isAlert;
					} else if (eventType === 'smart_event') {
						return item.metadata && item.metadata.isSmartEvent;
					} else if (eventType === 'axle') {
						return item.metadata && item.metadata.isAxle;
					} else if (eventType === 'counter') {
						return item.metadata && item.metadata.isCounter;
					}
					return false;
				});

				// Ordenar por timestamp
				this.alertSmartEventsInCategory.sort((a, b) => {
					const timestampA = a.metadata?.unixTimestamp || a.start;
					const timestampB = b.metadata?.unixTimestamp || b.start;
					return timestampA - timestampB;
				});

				// Encontrar el índice del evento actual
				this.currentAlertSmartIndex = this.alertSmartEventsInCategory.findIndex(item => 
					item.id === currentEvent.id
				);

				if (this.currentAlertSmartIndex === -1) {
					this.currentAlertSmartIndex = 0;
				}

				console.log('Alert/Smart events in category:', this.alertSmartEventsInCategory);
				console.log('Current Alert/Smart index:', this.currentAlertSmartIndex);

			} catch (error) {
				console.error('Error loading Alert/Smart events in category:', error);
			}
		},

		navigateToPreviousAlertSmart() {
			try {
				if (!this.canNavigateAlertSmartPrevious) {
					console.warn('Cannot navigate to previous Alert/Smart event');
					return;
				}

				const previousIndex = this.currentAlertSmartIndex - 1;
				const previousEvent = this.alertSmartEventsInCategory[previousIndex];

				console.log('Navigating to previous Alert/Smart event:', previousEvent);

				if (previousEvent) {
					this.navigateToAlertSmart(previousEvent, previousIndex);
				}

			} catch (error) {
				console.error('Error navigating to previous Alert/Smart event:', error);
			}
		},

		navigateToNextAlertSmart() {
			try {
				if (!this.canNavigateAlertSmartNext) {
					console.warn('Cannot navigate to next Alert/Smart event');
					return;
				}

				const nextIndex = this.currentAlertSmartIndex + 1;
				const nextEvent = this.alertSmartEventsInCategory[nextIndex];

				console.log('Navigating to next Alert/Smart event:', nextEvent);

				if (nextEvent) {
					this.navigateToAlertSmart(nextEvent, nextIndex);
				}

			} catch (error) {
				console.error('Error navigating to next Alert/Smart event:', error);
			}
		},

		navigateToAlertSmart(event, index) {
			try {
				console.log('Navigating to Alert/Smart event:', event, 'at index:', index);

				// Actualizar índice actual
				this.currentAlertSmartIndex = index;

				// Actualizar datos del evento
				this.alertSmartEventData = event;

				// Limpiar datos que se recargan por evento (igual que al abrir el modal)
				this.alertSmartEventVideoData = null;
				this.alertSmartEventBucketEvents = [];

				// Obtener tipo y rango para cargar bucket events (counter, alert, smart_event, axle, object)
				const meta = event?.metadata || {};
				const startTs = meta.startTimestamp || (event.start ? (typeof event.start === 'object' ? event.start.getTime() : event.start) : null);
				const endTs = meta.endTimestamp || (event.end ? (typeof event.end === 'object' ? event.end.getTime() : event.end) : null);
				let bucketType = null;
				if (meta.isCounter) bucketType = 'counter';
				else if (meta.isAlert) bucketType = 'alert';
				else if (meta.isSmartEvent) bucketType = 'smart_event';
				else if (meta.isAxle) bucketType = 'axle';
				else if (meta.isObject) bucketType = 'object';

				if (meta.isBucket && startTs && endTs && bucketType) {
					this.loadBucketEvents({
						startTimestamp: startTs,
						endTimestamp: endTs,
						type: bucketType,
						eventData: event
					});
				}

				// Buscar video para el nuevo evento
				const timestamp = meta.unixTimestamp || event.start;
				const deviceId = meta.deviceId || this.search?.deviceId;

				if (timestamp) {
					this.$nextTick(() => {
						this.searchVideoForAlertSmartEvent({
							timestamp: timestamp,
							deviceId: deviceId,
							eventData: event
						});
					});
				}

				console.log('Alert/Smart navigation completed to event:', event.id);

			} catch (error) {
				console.error('Error navigating to Alert/Smart event:', error);
			}
		},

		// Métodos de navegación LPR
		initializeLPRNavigation(currentLPR) {
			try {
				if (!currentLPR || !currentLPR.metadata) {
					console.warn('Invalid LPR data for navigation initialization');
					return;
				}

				// Para LPR, agrupamos por plateNumber
				const plateNumber = currentLPR.metadata.plateNumber;
				
				this.currentLPRCategory = {
					plateNumber: plateNumber
				};

				console.log('Initializing LPR navigation for plate:', plateNumber);

				// Obtener todos los eventos LPR de la misma placa
				this.loadLPREventsInCategory(currentLPR);

			} catch (error) {
				console.error('Error initializing LPR navigation:', error);
			}
		},

		loadLPREventsInCategory(currentLPR) {
			try {
				// Obtener items del timeline
				if (!this.$refs.timelinePlayback || !this.$refs.timelinePlayback.items) {
					console.warn('TimelinePlayback reference not available');
					return;
				}

				const allItems = this.$refs.timelinePlayback.items;
				console.log('All timeline items:', allItems);

				// Filtrar eventos LPR de la misma placa
				this.lprEventsInCategory = allItems.filter(item => {
					return item.metadata && 
						   item.metadata.isLPR &&
						   item.metadata.plateNumber === this.currentLPRCategory.plateNumber;
				});

				// Ordenar por timestamp
				this.lprEventsInCategory.sort((a, b) => {
					const timestampA = a.metadata?.unixTimestamp || a.start;
					const timestampB = b.metadata?.unixTimestamp || b.start;
					return timestampA - timestampB;
				});

				// Encontrar el índice del evento LPR actual
				this.currentLPRIndex = this.lprEventsInCategory.findIndex(item => 
					item.id === currentLPR.id
				);

				if (this.currentLPRIndex === -1) {
					this.currentLPRIndex = 0;
				}

				console.log('LPR events in category:', this.lprEventsInCategory);
				console.log('Current LPR index:', this.currentLPRIndex);

			} catch (error) {
				console.error('Error loading LPR events in category:', error);
			}
		},

		navigateToPreviousLPR() {
			try {
				if (!this.canNavigateLPRPrevious) {
					console.warn('Cannot navigate to previous LPR event');
					return;
				}

				const previousIndex = this.currentLPRIndex - 1;
				const previousLPR = this.lprEventsInCategory[previousIndex];

				console.log('Navigating to previous LPR event:', previousLPR);

				if (previousLPR) {
					this.navigateToLPR(previousLPR, previousIndex);
				}

			} catch (error) {
				console.error('Error navigating to previous LPR event:', error);
			}
		},

		navigateToNextLPR() {
			try {
				if (!this.canNavigateLPRNext) {
					console.warn('Cannot navigate to next LPR event');
					return;
				}

				const nextIndex = this.currentLPRIndex + 1;
				const nextLPR = this.lprEventsInCategory[nextIndex];

				console.log('Navigating to next LPR event:', nextLPR);

				if (nextLPR) {
					this.navigateToLPR(nextLPR, nextIndex);
				}

			} catch (error) {
				console.error('Error navigating to next LPR event:', error);
			}
		},

		navigateToLPR(lprEvent, index) {
			try {
				console.log('Navigating to LPR event:', lprEvent, 'at index:', index);

				// Actualizar índice actual
				this.currentLPRIndex = index;

				// Actualizar datos del evento LPR
				this.lprEventData = lprEvent;

				// Limpiar datos de video anteriores
				this.lprVideoData = null;

				// Buscar video para el nuevo evento LPR
				const timestamp = lprEvent.metadata?.unixTimestamp || lprEvent.start;
				const deviceId = lprEvent.metadata?.deviceId || this.search?.deviceId;

				if (timestamp) {
					this.$nextTick(() => {
						this.searchVideoForLPR({
							timestamp: timestamp,
							deviceId: deviceId,
							eventData: lprEvent
						});
					});
				}

				console.log('LPR navigation completed to event:', lprEvent.id);

			} catch (error) {
				console.error('Error navigating to LPR event:', error);
			}
		},

		// Método para manejar clics en eventos de alerta
		handleAlertEventClick(eventData) {
			console.log('Alert Event clicked:', eventData);
			
			// Guardar datos del evento
			this.alertSmartEventData = eventData.eventData;
			
			// Limpiar eventos anteriores
			this.alertSmartEventBucketEvents = [];
			
			// Inicializar navegación
			this.initializeAlertSmartNavigation(eventData.eventData, 'alert');
			
			// Mostrar el modal
			this.showAlertSmartEventModal = true;
			
			// Buscar eventos del bucket si es un bucket
			if (eventData.eventData?.metadata?.isBucket && eventData.startTimestamp && eventData.endTimestamp) {
				this.loadBucketEvents({
					startTimestamp: eventData.startTimestamp,
					endTimestamp: eventData.endTimestamp,
					type: 'alert',
					eventData: eventData.eventData
				});
			}
			
			// Buscar video automáticamente
			this.$nextTick(() => {
				this.searchVideoForAlertSmartEvent({
					timestamp: eventData.timestamp,
					deviceId: eventData.deviceId,
					eventData: eventData.eventData
				});
			});
		},

		// Método para manejar clics en smart events
		handleSmartEventClick(eventData) {
			console.log('Smart Event clicked:', eventData);
			
			// Guardar datos del evento
			this.alertSmartEventData = eventData.eventData;
			
			// Limpiar eventos anteriores
			this.alertSmartEventBucketEvents = [];
			
			// Inicializar navegación
			this.initializeAlertSmartNavigation(eventData.eventData, 'smart_event');
			
			// Mostrar el modal
			this.showAlertSmartEventModal = true;
			
			// Buscar eventos del bucket si es un bucket
			if (eventData.eventData?.metadata?.isBucket && eventData.startTimestamp && eventData.endTimestamp) {
				this.loadBucketEvents({
					startTimestamp: eventData.startTimestamp,
					endTimestamp: eventData.endTimestamp,
					type: 'smartEvent',
					eventData: eventData.eventData
				});
			}
			
			// Buscar video automáticamente
			this.$nextTick(() => {
				this.searchVideoForAlertSmartEvent({
					timestamp: eventData.timestamp,
					deviceId: eventData.deviceId,
					eventData: eventData.eventData
				});
			});
		},

		// Método para manejar clics en eventos de objetos
		handleObjectEventClick(eventData) {
			console.log('Object Event clicked:', eventData);
			
			// Guardar datos del evento
			this.objectEventData = eventData.eventData;
			
			// Limpiar eventos anteriores
			this.alertSmartEventBucketEvents = [];
			
			// Inicializar navegación
			this.initializeObjectNavigation(eventData.eventData);
			
			// Mostrar el modal (usando el mismo modal AlertSmartEventModal)
			this.showAlertSmartEventModal = true;
			this.alertSmartEventData = eventData.eventData;
			
			// Buscar eventos del bucket si es un bucket
			if (eventData.eventData?.metadata?.isBucket && eventData.startTimestamp && eventData.endTimestamp) {
				this.loadBucketEvents({
					startTimestamp: eventData.startTimestamp,
					endTimestamp: eventData.endTimestamp,
					type: 'objects',
					eventData: eventData.eventData
				});
			}
			
			// Buscar video automáticamente - usar el mismo método que smart events para que funcione con el modal
			const timestamp = eventData.timestamp || eventData.eventData?.metadata?.unixTimestamp || eventData.eventData?.start;
			const deviceId = eventData.deviceId || this.search?.deviceId || eventData.eventData?.metadata?.deviceId;
			
			
			
			if (timestamp) {
				this.$nextTick(() => {
					// Usar el mismo método que smart events para que el modal reciba el video
					this.searchVideoForAlertSmartEvent({
						timestamp: timestamp,
						deviceId: deviceId,
						eventData: eventData.eventData
					});
				});
			} else {
				console.warn('No timestamp available for video search');
			}
			
			// Mostrar información del objeto en consola
			
		},

		// Método para cerrar el modal de Alert & Smart Event
		closeAlertSmartEventModal() {
			this.showAlertSmartEventModal = false;
			this.alertSmartEventData = null;
			this.alertSmartEventVideoData = null;
			this.alertSmartEventBucketEvents = [];
			this.alertSmartEventLoadingEvents = false;
			// Limpiar navegación
			this.currentAlertSmartIndex = 0;
			this.alertSmartEventsInCategory = [];
			this.currentAlertSmartCategory = null;
		},

		// Método para manejar clics en axle events
		handleAxleClick(eventData) {
			console.log('Axle Event clicked:', eventData);
			
			// Guardar datos del evento
			this.alertSmartEventData = eventData.eventData;
			
			// Limpiar eventos anteriores
			this.alertSmartEventBucketEvents = [];
			
			// Inicializar navegación
			this.initializeAlertSmartNavigation(eventData.eventData, 'axle');
			
			// Mostrar el modal
			this.showAlertSmartEventModal = true;
			
			// Buscar eventos del bucket si es un bucket
			if (eventData.eventData?.metadata?.isBucket && eventData.startTimestamp && eventData.endTimestamp) {
				this.loadBucketEvents({
					startTimestamp: eventData.startTimestamp,
					endTimestamp: eventData.endTimestamp,
					type: 'axle',
					eventData: eventData.eventData
				});
			}
			
			// Buscar video automáticamente
			this.$nextTick(() => {
				this.searchVideoForAlertSmartEvent({
					timestamp: eventData.timestamp,
					deviceId: eventData.deviceId,
					eventData: eventData.eventData
				});
			});
		},

		// Método para manejar clics en counter events
		handleCounterClick(eventData) {
			console.log('Counter Event clicked:', eventData);
			
			// Guardar datos del evento
			this.alertSmartEventData = eventData.eventData;
			
			// Limpiar eventos anteriores
			this.alertSmartEventBucketEvents = [];
			
			// Inicializar navegación
			this.initializeAlertSmartNavigation(eventData.eventData, 'counter');
			
			// Mostrar el modal
			this.showAlertSmartEventModal = true;
			
			// Buscar eventos del bucket si es un bucket
			if (eventData.eventData?.metadata?.isBucket && eventData.startTimestamp && eventData.endTimestamp) {
				this.loadBucketEvents({
					startTimestamp: eventData.startTimestamp,
					endTimestamp: eventData.endTimestamp,
					type: 'counter',
					eventData: eventData.eventData
				});
			}
			
			// Buscar video automáticamente
			this.$nextTick(() => {
				this.searchVideoForAlertSmartEvent({
					timestamp: eventData.timestamp,
					deviceId: eventData.deviceId,
					eventData: eventData.eventData
				});
			});
		},
		
		// Método para mapear el tipo de evento al tipo del API
		getEventTypeForAPI(eventType) {
			const typeMap = {
				'smart_event': 'smartEvent',
				'alert': 'Alert',
				'lpr': 'LPR',
				'action': 'Action',
				'object': 'objects',
				'axle': 'Axle',
				'counter': 'Counter'
			};
			return typeMap[eventType] || 'smartEvent';
		},
		
		// Método para cargar eventos del bucket desde el API
		async loadBucketEvents(params) {
			const { startTimestamp, endTimestamp, type, eventData } = params;
			
			if (!startTimestamp || !endTimestamp || !type) {
				console.warn('Missing required parameters for bucket events:', { startTimestamp, endTimestamp, type });
				return;
			}
			
			// Mapear el tipo de evento al formato del API
			const apiType = this.getEventTypeForAPI(type);
			
			this.alertSmartEventLoadingEvents = true;
			
			try {
				const apiUrl = this.$URL + '/api/v1/records/events_by_range';
				const payload = {
					startTimestamp: startTimestamp,
					endTimestamp: endTimestamp,
					type: apiType
				};
				
				console.log('Loading bucket events:', payload);
				
				const response = await this.$axios.post(apiUrl, payload);
				
				
				
				if (response && response.data) {
					// Procesar los eventos recibidos
					let events = [];
					
					if (Array.isArray(response.data)) {
						events = response.data;
					} else if (response.data.events && Array.isArray(response.data.events)) {
						events = response.data.events;
					} else if (response.data.data && Array.isArray(response.data.data)) {
						events = response.data.data;
					} else if (response.data.rows && Array.isArray(response.data.rows)) {
						events = response.data.rows;
					}
					
					this.alertSmartEventBucketEvents = events;
					
				} else {
					console.warn('No data received from events_by_range endpoint');
					this.alertSmartEventBucketEvents = [];
				}
			} catch (error) {
				console.error('Error loading bucket events:', error);
				this.alertSmartEventBucketEvents = [];
			} finally {
				this.alertSmartEventLoadingEvents = false;
			}
		},

		// Método para cerrar el modal de Object Events
		closeObjectModal() {
			this.showObjectModal = false;
			this.objectEventData = null;
			this.objectVideoData = null;
			this.objectVideoLoading = false;
			this.objectVideoError = false;
			// Limpiar navegación
			this.currentObjectIndex = 0;
			this.objectsInCategory = [];
			this.currentObjectCategory = null;
		},

		// Método para buscar video para el evento de objeto
		async searchVideoForObjectEvent(searchData) {
			try {
				console.log('Searching video for Object event:', searchData);
				
				// Activar loading state
				this.objectVideoLoading = true;
				this.objectVideoError = false;
				this.objectVideoData = null;
				
				// Convertir timestamp a número si es string
				let timestamp = searchData.timestamp;
				if (typeof timestamp === 'string') {
					timestamp = parseInt(timestamp);
				}
				
				// Validar timestamp
				if (!timestamp || isNaN(timestamp)) {
					console.warn('Invalid timestamp for video search:', timestamp);
					this.objectVideoError = true;
					return;
				}
				
				// Usar el método del TimelinePlayback para buscar video
				if (this.$refs.timelinePlayback && this.$refs.timelinePlayback.findClosestVideoByTimestamp) {
					const result = await this.$refs.timelinePlayback.findClosestVideoByTimestamp(
						timestamp,
						searchData.deviceId
					);
					
					
					
					if (result && result.success && result.videoData && result.videoData.closestVideo) {
						this.objectVideoData = {
							videoUrl: this.$URL + result.videoData.closestVideo.urlpath,
							videoData: result.videoData,
							searchResult: result
						};
						
						console.log('Object video data set:', this.objectVideoData);
					} else {
						console.warn('No video found for Object event:', result);
						this.objectVideoError = true;
						this.objectVideoData = null;
					}
				} else {
					console.warn('TimelinePlayback reference not available');
					this.objectVideoError = true;
				}
			} catch (error) {
				console.error('Error searching video for Object event:', error);
				this.objectVideoError = true;
				this.objectVideoData = null;
			} finally {
				this.objectVideoLoading = false;
			}
		},

		// Método para manejar clics en grabaciones
		handleRecordingClick(recordingData) {
			//console.log('Recording clicked:', recordingData);
			
			if (!recordingData || !recordingData.filePath) {
				console.warn('No recording data or file path available');
				return;
			}

			// Construir la URL completa del video
			const videoUrl = recordingData.filePath.startsWith('http') 
				? recordingData.filePath 
				: `${this.$URL}${recordingData.filePath}`;

			
			
			// Establecer la URL del video para reproducir
			this.url_video = videoUrl;
			
			// Si hay un reproductor de video, reproducir automáticamente
			if (this.$refs.video_play) {
				this.$nextTick(() => {
					const videoElement = this.$refs.video_play;
					if (videoElement) {
						videoElement.load();
						videoElement.play().catch(error => {
							console.warn('Error playing video:', error);
						});
					}
				});
			}
		},

		// Método para buscar video para Alert & Smart Event
		async searchVideoForAlertSmartEvent(searchData) {
			try {
				console.log('Searching video for Alert/Smart Event:', searchData);
				
				let timestamp = searchData.timestamp;
				if (typeof timestamp === 'string') {
					timestamp = parseInt(timestamp);
				}
				
				if (this.$refs.timelinePlayback && this.$refs.timelinePlayback.findClosestVideoByTimestamp) {
					const result = await this.$refs.timelinePlayback.findClosestVideoByTimestamp(
						timestamp,
						searchData.deviceId
					);
					
					
					
					const videoAlert = result && result.videoData && (result.videoData.video || result.videoData.closestVideo);
					if (result && result.success && result.videoData && videoAlert && videoAlert.urlpath) {
						this.alertSmartEventVideoData = {
							videoUrl: this.$URL + videoAlert.urlpath,
							videoData: result.videoData,
							searchResult: result
						};
						
						
						
						// Notificar al modal que se encontró el video
						this.$nextTick(() => {
							if (this.$refs.alertSmartEventModal) {
								this.$refs.alertSmartEventModal.setVideoData(this.alertSmartEventVideoData);
							}
						});
					} else {
						console.warn('No video found for Alert/Smart Event:', result);
						// Limpiar datos de video si no se encuentra
						this.alertSmartEventVideoData = null;
					}
				} else {
					console.warn('TimelinePlayback reference not available');
				}
			} catch (error) {
				console.error('Error searching video for Alert/Smart Event:', error);
				this.alertSmartEventVideoData = null;
			}
		},

		// Método para formatear fechas del timeline
		formatTimelineDate(dateString) {
			if (!dateString) return 'N/A';
			
			try {
				const date = new Date(dateString);
				if (isNaN(date.getTime())) return 'Invalid Date';
				
				// Formato: DD/MM/YYYY HH:MM:SS
				return date.toLocaleString('es-ES', {
					day: '2-digit',
					month: '2-digit',
					year: 'numeric',
					hour: '2-digit',
					minute: '2-digit',
					second: '2-digit'
				});
			} catch (error) {
				// console.error("❌ [Playback] Error formatting timeline date:", error);
				return 'Error';
			}
		},

		// Método para manejar la carga exitosa de imagen
		onImageLoad(event) {
			// Limpiar timeout ya que la imagen se cargó exitosamente
			if (this.imageLoadTimeout) {
				clearTimeout(this.imageLoadTimeout);
				this.imageLoadTimeout = null;
			}
			
			// Limpiar AbortController ya que la carga fue exitosa
			if (this.currentImageLoadAbortController) {
				this.currentImageLoadAbortController = null;
			}
			
			// Ocultar mensaje de error si existe
			const img = event.target;
			const container = img.parentElement;
			const errorMsg = container.querySelector('.image-error-message');
			if (errorMsg) {
				errorMsg.style.display = 'none';
			}
		},

		// Método para manejar errores de carga de imágenes
		handleImageError(event) {
			const img = event.target;
			img.style.display = 'none';
			
			// Mostrar mensaje de error en lugar de la imagen
			const container = img.parentElement;
			if (container) {
				const errorMsg = document.createElement('div');
				errorMsg.className = 'image-error-message';
				errorMsg.innerHTML = `
					<v-icon small color="error">mdi-image-off</v-icon>
					<span class="text-caption text-grey">Image not available</span>
				`;
				container.appendChild(errorMsg);
			}
		},

		// Método para construir la URL de evidencia
		getEvidenceUrl(evidence) {
			if (!evidence) return '';
			
			// Si la evidencia empieza con //, construir la URL completa
			if (evidence.startsWith('//')) {
				return this.$URL+evidence;
			}
			
			// Si ya es una URL completa, devolverla tal como está
			if (evidence.startsWith('http')) {
				return evidence;
			}
			
			// Si es una ruta relativa, agregar la URL base con barra diagonal
			const baseUrl = this.$URL ;
			const separator = baseUrl.endsWith('/') || evidence.startsWith('/') ? '' : '/';
			return `${baseUrl}${separator}${evidence}`;
		},

		// Método para determinar si debe mostrar el layout de 2 columnas
		shouldShowTwoColumnLayout(item) {
			if (!item || !item.metadata) return false;
			
			return item.metadata.isAlert || 
				   item.metadata.isSmartEvent || 
				   item.metadata.isLPR ||
				   item.metadata.eventType === 'lpr' ||
				   (item.id && typeof item.id === 'string' && (item.id.startsWith('alert') || item.id.startsWith('smartEvent') || item.id.startsWith('lpr')));
		},

		// Método para cancelar la carga anterior de imágenes
		cancelPreviousImageLoad() {
			// Cancelar AbortController anterior si existe
			if (this.currentImageLoadAbortController) {
				try {
					this.currentImageLoadAbortController.abort();
				} catch (error) {
					// Ignorar errores al cancelar
				}
				this.currentImageLoadAbortController = null;
			}
			
			// Limpiar timeout anterior si existe
			if (this.imageLoadTimeout) {
				clearTimeout(this.imageLoadTimeout);
				this.imageLoadTimeout = null;
			}
		},

		// Método para obtener la URL de evidencia del evento (sin efectos secundarios)
		getEventEvidenceUrl(item) {
			if (!item || !item.metadata) return '';
			
			let evidenceUrl = '';
			
			// Para alertas
			if (item.metadata.isAlert && item.metadata.alert && item.metadata.alert.evidence) {
				evidenceUrl = this.getEvidenceUrl(item.metadata.alert.evidence);
			}
			// Para smart events
			else if (item.metadata.isSmartEvent && item.metadata.smartEvent && item.metadata.smartEvent.evidence) {
				evidenceUrl = this.getEvidenceUrl(item.metadata.smartEvent.evidence);
			}
			// Para LPR y otros eventos
			else if (item.metadata.evidence) {
				evidenceUrl = this.getEvidenceUrl(item.metadata.evidence);
			}
			
			return evidenceUrl;
		},

		// Método separado para manejar la carga de imagen (con efectos secundarios)
		handleImageLoadStart(item) {
			// Solo proceder si hay una URL válida
			if (!this.currentEvidenceUrl) return;
			
			// Crear nuevo AbortController para esta carga
			this.currentImageLoadAbortController = new AbortController();
			
			// Configurar timeout para cancelar si tarda mucho
			this.imageLoadTimeout = setTimeout(() => {
				if (this.currentImageLoadAbortController) {
					this.currentImageLoadAbortController.abort();
					this.currentImageLoadAbortController = null;
				}
			}, 5000); // 5 segundos para dar tiempo a la carga
		},

		// Método para obtener el tipo de evento
		getEventType(item) {
			if (!item || !item.metadata) return 'Event';
			
			if (item.metadata.isAlert) return 'Alert';
			if (item.metadata.isSmartEvent) return 'Smart Event';
			if (item.metadata.isLPR) return 'LPR';
			if (item.metadata.isAction) return 'Action';
			
			// Verificar por eventType
			if (item.metadata.eventType === 'lpr') return 'LPR';
			if (item.metadata.eventType === 'alert') return 'Alert';
			if (item.metadata.eventType === 'smartEvent') return 'Smart Event';
			if (item.metadata.eventType === 'action') return 'Action';
			
			// Verificar por ID
			if (item.id && typeof item.id === 'string') {
				if (item.id.startsWith('alert')) return 'Alert';
				if (item.id.startsWith('smartEvent')) return 'Smart Event';
				if (item.id.startsWith('lpr')) return 'LPR';
				if (item.id.startsWith('action')) return 'Action';
			}
			
			return 'Event';
		},

		// Método para obtener el icono del evento
		getEventIcon(item) {
			if (!item || !item.metadata) return 'mdi-help-circle';
			
			if (item.metadata.isAlert || (item.id && typeof item.id === 'string' && item.id.startsWith('alert'))) return 'mdi-alert';
			if (item.metadata.isSmartEvent || (item.id && typeof item.id === 'string' && item.id.startsWith('smartEvent'))) return 'mdi-brain';
			if (item.metadata.isLPR || item.metadata.eventType === 'lpr' || (item.id && typeof item.id === 'string' && item.id.startsWith('lpr'))) return 'mdi-car';
			if (item.metadata.isAction || (item.id && typeof item.id === 'string' && item.id.startsWith('action'))) return 'mdi-lightning-bolt';
			
			return 'mdi-help-circle';
		},

		// Método para obtener el color del evento
		getEventColor(item) {
			if (!item || !item.metadata) return '#1976d2';
			
			if (item.metadata.isAlert || (item.id && typeof item.id === 'string' && item.id.startsWith('alert'))) return '#d32f2f';
			if (item.metadata.isSmartEvent || (item.id && typeof item.id === 'string' && item.id.startsWith('smartEvent'))) return '#7b1fa2';
			if (item.metadata.isLPR || item.metadata.eventType === 'lpr' || (item.id && typeof item.id === 'string' && item.id.startsWith('lpr'))) return '#388e3c';
			if (item.metadata.isAction || (item.id && typeof item.id === 'string' && item.id.startsWith('action'))) return '#f57c00';
			
			return '#1976d2';
		},

	}, // methods
	
	// Watchers
	watch: {
		timelineHoverInfo: {
			handler(newValue, oldValue) {
				// Optimización: Solo procesar si realmente cambió el item (comparar por ID)
				const newItemId = newValue?.item?.id;
				const oldItemId = oldValue?.item?.id;
				
				// Si es el mismo item, no hacer nada para evitar memory leaks
				if (newItemId && oldItemId && newItemId === oldItemId) {
					return;
				}
				
				if (newValue && newValue.item) {
					const shouldShow = this.shouldShowTwoColumnLayout(newValue.item);
					
					if (shouldShow) {
						// Cancelar carga anterior solo si es un item diferente
						if (oldValue && oldValue.item && oldValue.item.id !== newValue.item.id) {
							this.cancelPreviousImageLoad();
						}
						
						// Actualizar URL de evidencia
						const newUrl = this.getEventEvidenceUrl(newValue.item);
						
						this.currentEvidenceUrl = newUrl;
						
						// Manejar carga de imagen
						this.handleImageLoadStart(newValue.item);
					} else {
						// Cancelar carga anterior y limpiar URL
						this.cancelPreviousImageLoad();
						this.currentEvidenceUrl = '';
					}
				} else {
					// Limpiar completamente cuando se sale del hover
					this.cancelPreviousImageLoad();
					this.currentEvidenceUrl = '';
					
					// Cancelar carga anterior y limpiar URL
					this.cancelPreviousImageLoad();
					this.currentEvidenceUrl = '';
				}
				
				
			},
			immediate: true
		}
	},
	
	// Lifecycle hooks
	mounted(){
		this.onResize();
		
		// Inicializar la referencia del reproductor de video si ya existe
		this.$nextTick(() => {
			if (this.$refs.video_play) {
				this.videoPlayerRef = this.$refs.video_play;
				
			}
		});
		
		let temp_bus = 'keyboard_type' + this.ID_notification;
		EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
			if (action) {				
				if (action.setting) {
					let { obj, key, type } =  action.setting;
					if (type == 'text') {
						this[key] = action.input;
					}else{
						this[obj][key] = action.input;
					}
				}
			}
		});
        EventBus.$on("responsive", this.bus['responsive'] = (resize) =>{
        	this.onResize();
        });
	}, // mounted

	beforeDestroy(){
		// Limpiar cargas de imágenes al destruir el componente
		this.cancelPreviousImageLoad();
		
		// Limpiar hover info para liberar memoria
		if (this.timelineHoverInfo) {
			this.timelineHoverInfo = null;
		}
		
		// Clean up Intersection Observer
		if (this.intersectionObserver) {
			this.intersectionObserver.disconnect();
			this.intersectionObserver = null;
		}
		
		if (this.bus) {
			this.$Helper.clear_bus(EventBus, this.bus, 'playback');
		}		

	}, // before Destroy
};